import React, { useEffect } from 'react';
import { X, ChevronLeft, ChevronRight, Heart, Download, Send, MessageSquare } from 'lucide-react';
import { useState } from 'react';

const PhotoLightbox = ({ photos, index, onClose, onIndex, onLike, onComment, onDownload, clientName }) => {
  const [text, setText] = useState('');
  const p = photos[index];

  useEffect(() => {
    const onKey = (e) => {
      if (e.target && ['INPUT','TEXTAREA'].includes(e.target.tagName)) return;
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') onIndex(Math.min(photos.length - 1, index + 1));
      if (e.key === 'ArrowLeft') onIndex(Math.max(0, index - 1));
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [index, photos.length, onClose, onIndex]);

  if (!p) return null;
  const liked = (p.likes_by || []).includes(clientName);

  return (
    <div className="fixed inset-0 z-50 bg-black/95 flex flex-col md:flex-row overflow-y-auto md:overflow-hidden">
      <button onClick={onClose} className="fixed top-4 right-4 z-20 w-10 h-10 rounded-full bg-white/10 text-white grid place-items-center hover:bg-white/20"><X className="w-5 h-5" /></button>

      <div className="relative flex-1 flex items-center justify-center p-4 shrink-0 md:shrink">
        <button disabled={index===0} onClick={()=>onIndex(index-1)} className="absolute left-4 w-10 h-10 rounded-full bg-white/10 text-white grid place-items-center hover:bg-white/20 disabled:opacity-30"><ChevronLeft className="w-5 h-5" /></button>
        <img src={p.url} alt={p.filename} className="max-h-[55vh] md:max-h-[90vh] max-w-full object-contain rounded-lg" />
        <button disabled={index===photos.length-1} onClick={()=>onIndex(index+1)} className="absolute right-4 w-10 h-10 rounded-full bg-white/10 text-white grid place-items-center hover:bg-white/20 disabled:opacity-30"><ChevronRight className="w-5 h-5" /></button>
      </div>

      <aside className="md:w-96 bg-slate-900 text-slate-100 flex flex-col border-l border-white/10 shrink-0 md:shrink md:h-auto">
        <div className="p-4 border-b border-white/10">
          <p className="text-xs text-slate-400">{p.filename}</p>
          <p className="text-xs text-slate-500 mt-1">Foto {index+1} di {photos.length}</p>
          <div className="flex items-center gap-2 mt-3">
            <button onClick={()=>onLike(p.id)} className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium ${liked ? 'bg-rose-500 text-white' : 'bg-white/10 hover:bg-white/20'}`}>
              <Heart className={`w-3.5 h-3.5 ${liked ? 'fill-current' : ''}`} /> {p.likes || (p.likes_by || []).length} Like
            </button>
            <button onClick={()=>onDownload(p.url, p.filename)} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium bg-white/10 hover:bg-white/20">
              <Download className="w-3.5 h-3.5" /> Scarica
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-4 max-h-[35vh] md:max-h-none">
          <div className="flex items-center gap-2 text-sm font-semibold text-slate-200 mb-3"><MessageSquare className="w-4 h-4" /> Commenti ({(p.comments||[]).length})</div>
          <div className="space-y-3">
            {(p.comments || []).length === 0 && <p className="text-xs text-slate-500">Nessun commento ancora. Scrivi il primo!</p>}
            {(p.comments || []).map(c => (
              <div key={c.id} className="bg-white/5 rounded-lg p-3">
                <div className="flex items-center justify-between">
                  <span className="text-xs font-semibold text-[#C9A961]">{c.author}</span>
                  <span className="text-[10px] text-slate-500">{c.created_at ? new Date(c.created_at).toLocaleString('it-IT', { day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit' }) : ''}</span>
                </div>
                <p className="text-sm text-slate-200 mt-1 leading-relaxed whitespace-pre-wrap">{c.text}</p>
              </div>
            ))}
          </div>
        </div>

        <form onSubmit={(e)=>{e.preventDefault(); onComment(p.id, text); setText('');}} className="p-3 border-t border-white/10 flex items-center gap-2">
          <input data-testid="comment-input" value={text} onChange={e=>setText(e.target.value)} placeholder="Scrivi un commento..." className="flex-1 bg-white/5 border border-white/10 rounded-full px-4 py-2 text-sm outline-none focus:border-[#C9A961] text-white" />
          <button data-testid="comment-send-btn" type="submit" className="w-9 h-9 rounded-full bg-[#C9A961] hover:bg-white text-black grid place-items-center shrink-0"><Send className="w-4 h-4" /></button>
        </form>
      </aside>
    </div>
  );
};

export default PhotoLightbox;
